// extracted by mini-css-extract-plugin
export default {"QuestionBox":"QuestionTitle_QuestionBox__y86Uk","QuestionTitle":"QuestionTitle_QuestionTitle__gimA4"};